import { render, staticRenderFns } from "./rego-customer-link-bank.vue?vue&type=template&id=3f8a78b6&scoped=true&"
import script from "./rego-customer-link-bank.vue?vue&type=script&lang=js&"
export * from "./rego-customer-link-bank.vue?vue&type=script&lang=js&"
import style0 from "./rego-customer-link-bank.vue?vue&type=style&index=0&id=3f8a78b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8a78b6",
  null
  
)

export default component.exports